import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListEmailCredentialPayload } from '@app-store/slices/emailCredential/list'

interface TaskAction extends Action {
    payload: IListEmailCredentialPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.emailCredential.list

function* listSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/notifications/email-credentials`, {
            params: {
                ...payload?.pagination
            }
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        // console.log(error)
        yield put(onFailure(error))
    }
}

function* listSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSagaTask)
}

export default listSaga
